import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import { initializeApp } from "firebase/app"
import ProductView from '../src/components/Product.vue';
import OrderView from '../src/components/Order.vue';
import RidersView from '../src/components/Riders.vue';
import CustomerView from '../src/components/Customer.vue';
import FeedbackView from '../src/components/Feedback.vue';
import ReviewView from '../src/components/Review.vue';
import SignIn from '../src/components/SignIn.vue'
import OrderDetails from './components/OrderDetails.vue'
import Messages from './components/Messages.vue'
import RevampedFeedback from './components/RevampedFeedback.vue'
import FeedbackMedia from './components/FeedbackMedia.vue'

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

function guardMyRoute(to, from, next) {
  const token = localStorage.getItem('token');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (token != null && to.path != "/login") {
    const jwtPayload = parseJwt(token);
    console.log(jwtPayload)
    console.log(Date.now())
    if (jwtPayload.exp < Date.now() / 1000) {
      // token expired
      next('/login')
    }
    if (to.meta.roles && !to.meta.roles.includes(jwtPayload.role)) {
      return next("/login"); // or redirect somewhere safe
    }
    next();
  } else {
    next('/login')
  }
}

Vue.use(VueRouter)
const routes = [
  {
    path: "/",
    redirect: "products"
  },
  {
    path: '/products',
    name: 'ProductView',
    meta: { sidebar: true , roles: ["admin"]},
    beforeEnter: guardMyRoute,
    component: ProductView
  },
  {
    path: '/orders',
    name: 'OrderView',
    meta: { sidebar: true, roles: ["admin"] },
    beforeEnter: guardMyRoute,
    component: OrderView
  },
  {
    path: '/order-details/:id',
    name: 'OrderDetails',
    props: true,
    meta: { sidebar: true, roles: ["admin", "messages"] },
    beforeEnter: guardMyRoute,
    component: OrderDetails
  },
  {
    path: '/messages',
    name: 'MessagesList',
    props: true,
    meta: { sidebar: true, roles: ["admin", "messages"] },
    beforeEnter: guardMyRoute,
    component: Messages
  },
  {
    path: '/riders',
    name: 'RidersView',
    meta: { sidebar: true, roles: ["admin"] },
    beforeEnter: guardMyRoute,
    component: RidersView
  },
  {
    path: '/customers',
    name: 'CustomerView',
    meta: { sidebar: true, roles: ["admin"] },
    beforeEnter: guardMyRoute,
    component: CustomerView
  },
  {
    path: '/feedback',
    name: 'FeedbackView',
    meta: { sidebar: false },
    component: FeedbackView
  },
  {
    path: '/productfeedback',
    name: 'FeedbackNewView',
    meta: { sidebar: false },
    component: RevampedFeedback
  },
  {
    path: '/reviews',
    name: 'ReviewView',
    meta: { sidebar: true, roles: ["admin"] },
    beforeEnter: guardMyRoute,
    component: ReviewView
  },
  {
    path: '/login',
    name: 'SignIn',
    meta: { sidebar: false },
    component: SignIn
  },
  {
    path: '/feedbackMedia',
    name: 'FeedbackMediaApprove',
    meta: { sidebar: false },
    component: FeedbackMedia
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App),
  created() {
    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: "AIzaSyCWXEkT1myt8c5KzuCnf8nzRqOujLuQWs4",
      authDomain: "orders-union.firebaseapp.com",
      projectId: "orders-union",
      storageBucket: "orders-union.appspot.com",
      messagingSenderId: "749880646066",
      appId: "1:749880646066:web:774e25ec1dd96169d8acab"
    };

    // Initialize Firebase
    initializeApp(firebaseConfig);
  }
}).$mount('#app')
